var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDriveRecorderWh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,35V0H35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0-.75H16.905a.75.75,0,0,1,.75.75V4.438a.75.75,0,0,1-.75.75H0a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75ZM16.155.75H.75V3.688H16.155Z",
    transform: "translate(9.047 5.644)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0-.75H5.04A.75.75,0,0,1,5.79,0V4.054a.75.75,0,0,1-.75.75H0a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75ZM4.29.75H.75V3.3H4.29Z",
    transform: "translate(14.98 10.082)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0-.75H25.956a.75.75,0,0,1,.75.75V15.222a.75.75,0,0,1-.75.75H0a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75ZM25.206.75H.75V14.472H25.206Z",
    transform: "translate(4.521 14.135)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.9-.75A5.648,5.648,0,1,1-.75,4.9,5.654,5.654,0,0,1,4.9-.75Zm0,9.8A4.148,4.148,0,1,0,.75,4.9,4.153,4.153,0,0,0,4.9,9.046Z",
    transform: "translate(17.898 16.848)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.174-.75A2.924,2.924,0,1,1-.75,2.174,2.927,2.927,0,0,1,2.174-.75Zm0,4.348A1.424,1.424,0,1,0,.75,2.174,1.425,1.425,0,0,0,2.174,3.6Z",
    transform: "translate(7.34 16.848)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.174-.75A2.924,2.924,0,1,1-.75,2.174,2.927,2.927,0,0,1,2.174-.75Zm0,4.348A1.424,1.424,0,1,0,.75,2.174,1.425,1.425,0,0,0,2.174,3.6Z",
    transform: "translate(19.086 17.873)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriveRecorderWh);
export default __webpack_public_path__ + "static/media/icon_drive_recorder_wh.f34790a993a342434d78ab3ef8485bc9.svg";
export { ForwardRef as ReactComponent };